import React from 'react';
import './globals';
import './assets/css/bootstrap-qrsticker.min.css';
import App from './App';
import {Router} from 'react-router-dom';
import history from './authentication/History';
import {createRoot} from 'react-dom/client';

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
    <Router history={history}>
        <App tab="home"/>
    </Router>);
